module.exports = __webpack_public_path__ + "static/media/LOGOS3.ba6cbe11.png";